// Static anchor snapshot shipped to public/corpus/ at build time (SPEC "Build
// & ingest pipeline" §3): the syncAnchors sidecar is snapshotted at deploy
// alongside the exact corpus text it references, so the anonymous reader gets
// sync with no Convex round-trip and anchors can never drift from the deployed
// snapshot. Zod schema validates the JSON on fetch; TS types are inferred.

// Namespace import, not `import { z }` — zod ships CJS for the node
// condition and the named form resolves to `undefined` under vitest's
// multi-project run. Same fix as packages/logging/src/ingest.ts; it is
// zod 4's documented import form anyway.
import * as z from "zod";
import type { AnchorPair } from "@bindery/convex-retells/model/anchor";

/**
 * One anchor pair as serialized into the static corpus. `satisfies` pins the
 * shape to the shared `AnchorPair` (convex/model/anchor) so the snapshot can
 * never diverge from what the anchor editor stores.
 */
export const corpusAnchorPairSchema = z.object({
  originalOffset: z.number().int().nonnegative(),
  retelling: z.object({
    blockId: z.string(),
    offset: z.number().int().nonnegative(),
  }),
}) satisfies z.ZodType<AnchorPair>;
export type CorpusAnchorPair = z.infer<typeof corpusAnchorPairSchema>;

/**
 * Per-chapter-pair anchor list: ordered, strictly monotonic, one-to-one.
 * The document-start/end sentinel pairs stay implicit (computed at render
 * time), exactly as in Convex.
 */
export const corpusAnchorsSchema = z.object({
  anchors: z.array(corpusAnchorPairSchema),
});
export type CorpusAnchors = z.infer<typeof corpusAnchorsSchema>;
